<app-ice-radio-list-item
  testId="voice-offerings-list-item-input"
  [control]="control"
  [disabled]="isDisabled"
  [label]="offering.name"
  [matTooltip]="tooltipMessage"
  [value]="offering.id"
>
  <div inlineContent>
    <div class="price">
      @if (
        offering.monthlyPrice?.isCampaign &&
        offering.monthlyPrice?.originalPrice?.includingVAT > offering?.monthlyPrice?.price?.includingVAT
      ) {
        <span class="campaign-original-price">
          {{ offering.monthlyPrice.originalPrice | priceFormat: PriceType.OneTime }}
        </span>
      }
      <span class="monthly-price">{{ offering.monthlyPrice.price | priceFormat: PriceType.Monthly }}</span>
    </div>
  </div>
  <div class="content" content>
    <div class="subscription-binding-period">
      @if (offering.bindings?.length > 0) {
        m/startbrudd
        @if (offering.bindings[0]?.terminationFee) {
          {{ offering.bindings[0]?.terminationFee | priceFormat: PriceType.OneTime }}
        }
        <app-ice-info-icon [tooltip]="Messages.TerminationFee" />
      } @else {
        @if (existingBindingWillBeTransferred) {
          Viderefører avtaletid til {{ SubscriptionBindingExpirationDate(assignedSubscription) | date: 'dd.MM.yyyy' }}
        } @else {
          <div>ingen avtaletid</div>
        }
      }
      @if (isExistingSubscription && changeInfo?.triggersBreakageFee && changeInfo.remainingBreakageFee?.includingVAT > 0) {
        <div class="breakage-fee-message">
          <div class="change-subscription">
            {{ changeInfo.remainingBreakageFee | priceFormat: PriceType.OneTime }} i bruddgebyr
          </div>
        </div>
      }
    </div>
    @if (offering.benefitProgram === BenefitProgram.IceAmbassador) {
      <app-benefit-program-options
        [sponsor]="sponsor"
        (sponsorSelected)="sponsorSelected.emit($event)"
        (sponsorTypeSelected)="sponsorTypeSelected.emit($event)"
      />
    }
    @if (offering.monthlyPrice?.isCampaign && offering.monthlyPrice?.campaignPeriod > 0) {
      <app-ice-badge class="campaign-message" type="neutral">
        Rabatt i {{ offering.monthlyPrice.campaignPeriod }} måneder
      </app-ice-badge>
    }
  </div>
</app-ice-radio-list-item>
